import Http from '@/services/httpAcademy'

export const listReports           = (params)          => Http.get('/admin/reports', { params })
export const reviewReport          = ({ id, ...data }) => Http.patch(`/admin/reports/${id}/review`, data)
export const listReportCategories  = ()                => Http.get('/admin/report-categories')
export const createReportCategory  = (data)            => Http.post('/admin/report-categories', data)
export const updateReportCategory  = ({ id, ...data }) => Http.patch(`/admin/report-categories/${id}`, data)
export const deleteReportCategory  = (id)              => Http.delete(`/admin/report-categories/${id}`)
